/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from "react";

import styled from "styled-components";

import PropTypes from "prop-types";

import {WealthyEnv} from "helpers";

const tabOptions = [
  {
    name: "Mutual Funds",
    id: 1,
    header: "Choose from well researched basket of Mutual Funds",
    subHeader: "Create portfolios for clients based on their needs, time frame and risk taking ability.",
    image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-our-products-mf-icon.svg`,
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-products-mf-detail-image.webp`
  },
  {
    name: "Insurances",
    id: 2,
    header: "Life, Health and General insurance from top companies",
    subHeader: "Provide your clients with the best choice of Insurance across many companies at single place.",
    image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-our-products-insurances-icon.svg`,
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-products-insurance-detail-image.webp`,
    subImage: `${WealthyEnv.CDN_URL}/insurance/max_term_life_banner.webp`
  },
  {
    name: "Pre IPO",
    id: 3,
    header: "Opportunity to invest into shares even before the IPO",
    subHeader: "Make right investments of your clients capital into Shares even before market discovers them.",
    image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-our-products-ipo-icon.svg`,
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-products-ipo-detail-image.webp`
  },
  {
    name: "Debentures",
    id: 4,
    header: "Choice of High quality",
    headerOne: " MLDs, NCDs & Bonds",
    subHeader: "Advanced products for your High Net-worth clients, seeking higher fixed incomes.",
    image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-our-products-debentures-icon.svg`,
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-products-debentures-detail-image-webP.webp`
  },
  {
    name: "Fixed Deposits",
    id: 5,
    header: "Choose from varied corporate deposits for Higher than FD returns",
    subHeader: "Fixed Deposits that gives your client an opportunity to earn higher returns than their Bank.",
    image: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-our-products-fd-icon.svg`,
    detailImage: `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-products-fd-detail-image.webp`
  }
];

const buttonArrow = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-button-right-arrow.svg`;
const storeBriefcaseIcon = `${WealthyEnv.HOMEPAGE_CDN_URL}/partners-our-products-briefcase.svg`;


const propTypes = {
  activeTab: PropTypes.number.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  tabContentRef: PropTypes.object.isRequired
};

const OurProducts = ({
  activeTab,
  setActiveTab,
  tabContentRef
}) => {
  const selectedTabContent = tabOptions.filter((option) => option.id === activeTab)[0];

  return (
    <Wrapper id="all-products">
      <Title>
        <img alt="briefcase-icon" className="store-briefcase-icon" loading="lazy" src={storeBriefcaseIcon} />
        Wealthy Store
      </Title>
      <Subheading>Multiple Products on investments and insurance</Subheading>
      <TabsContainer>
        {
          tabOptions.map((option) => {
            return (
              <li
                className={activeTab === option.id ? "tab-title tab-title-active" : "tab-title"}
                key={option.id}
                onClick={() => {
                  tabContentRef.current.style.opacity = 0;
                  setTimeout(() => setActiveTab(option.id), 300);
                  setTimeout(() => {
                    tabContentRef.current.style.opacity = 1;
                  }, 500);
                }}
              >
                <Image>
                  <img  alt="tab-option-image" className="tab-option-image"  loading="lazy" src={option.image} />
                </Image>
                <Name>{option.name}</Name>
              </li>
            );
          }
          )
        }
      </TabsContainer>

      <TabContent ref={tabContentRef}>
        <ImageWrapper>
          <img alt="each-product-detail-image" className="selected-tab-image" loading="lazy" src={selectedTabContent.detailImage} />
        </ImageWrapper>
        <ContentWrapper>
          {
            selectedTabContent.subImage ? (
              <SubImageContainer >
                <SubImageText>MAX Life</SubImageText>
                <SubImage src={selectedTabContent.subImage} />
              </SubImageContainer>
            ) : ""
          }
          <Header>{selectedTabContent.header}</Header>
          {selectedTabContent.headerOne && selectedTabContent.headerOne.length > 0 && (
            <Header>{selectedTabContent.headerOne}</Header>
          )}
          <SubHeader>{selectedTabContent.subHeader}</SubHeader>
          <RegisterNowButton href="#register">
            Register Now
            <img alt="right-arrow-icon" className="button-arrow" loading="lazy" src={buttonArrow} />
          </RegisterNowButton>
        </ContentWrapper>
      </TabContent>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 5rem 0;
  margin: 0 auto;
  width: 85%;
`;

const SubImageText = styled.p`
  font-family: MavenPro;
  font-size: 2.4rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  text-align: left;
  color: #1c1c1c;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 2.4rem;
    line-height: 1.3;
    text-align: center;
  }
`;

const SubImageContainer = styled.a``;

const SubImage = styled.img`
  @media (max-width: 768px) {
    height: 15rem;
    width: 100%;
  }
`;

const TabContent = styled.div`
  display: flex;
  transition: opacity .4s cubic-bezier(0.25,0.46,0.45,0.94);
  justify-content: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const RegisterNowButton = styled.a`
  border-radius: 1.2rem;
  background-color: #6725f4;
  width: 18rem;
  height: 5.6rem;
  font-family: MavenPro;
  font-size: 1.8rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .button-arrow {
    margin-left: 1rem;
    vertical-align: middle;
    :hover {
      transition: all 300ms cubic-bezier(0.46,0.03,0.52,0.96);
      transform: rotate(360deg);
    }
  }

  :hover {
    transition: all 200ms cubic-bezier(0.46,0.03,0.52,0.96);
    box-shadow: 0 10px 10px rgba(0,0,0,0.2);
    transform: scale(1.02);

  }

  @media(max-width: 768px) {
    font-size: 1.8rem;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
`;



const ImageWrapper = styled.div`
  width: 50rem;
  height: 50rem;

  .selected-tab-image {
    width: 100%;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    height: 30rem;
    width: 30rem;
    margin: 0 auto 3rem;

    .selected-tab-image {
      width: 100%;
      object-fit: contain;
    }
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 33%;
  margin-left: 10rem;
  align-self: center;

  @media (max-width: 768px) {
    width: 100%;
    margin: 4rem auto 0 0;

  }
`;

const Header = styled.h2`
  font-family: MavenPro;
  font-size: 2.4rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.54;
  letter-spacing: normal;
  text-align: left;
  color: #1c1c1c;

  @media (max-width: 768px) {
    font-size: 2.4rem;
    line-height: 1.3;
    text-align: center;
  }
`;

const SubHeader = styled(Header)`
  font-size: 1.8rem;
  font-weight: normal;
  line-height: 1.78;
  margin-bottom: 4rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const Name = styled(Header)`
  font-weight: 500;
  line-height: normal;
  margin-bottom: 0;
  align-self: center;
  width: max-content;

  @media(max-width: 768px) {
    font-size: 1.8rem;
    width: max-content;
  }
`;

const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6rem;
  overflow: scroll;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  ::-webkit-scrollbar {
    display: none;
  }

  .tab-title {
    background-color: #fff;
    padding: 10px;
    color: #c7c6c2;
    cursor: pointer;
    display: flex;
    opacity: 0.3;
    align-items: center;
  }

  .tab-title-active {
    transition: border-bottom 0.2s;
    border-bottom: 2px solid #6725f4;
    opacity: 1;
  }

  @media (max-width: 768px) {
    margin-bottom: 4rem;
  }

`;

const Image = styled.div`
  height: 4rem;
  width: 4rem;
  margin-right: 1.2rem;

  @media(max-width: 768px) {
    height: 2.4rem;
    width: 2.4rem;
    .tab-option-image {
      height: 100%;
    }
  }
`;

const Title = styled.div`
  border-radius: 100rem;
  width: max-content;
  background-color: #f9f9f9;
  padding: 1rem 2rem;
  font-family: MavenPro;
  font-size: 2.4rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .store-briefcase-icon {
    margin-right: 1rem;
  }

  @media(max-width: 768px) {
    font-size: 1.8rem;
    padding: 0.5rem 1.4rem;

    .store-briefcase-icon {
      margin-right: 0.5rem;
      width: 18%;
    }
  }
`;

const Subheading = styled.h2`
  font-family: MavenPro;
  font-size: 3.6rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #1c1c1c;
  margin: 2rem 0 8rem;

  @media(max-width: 768px) {
    font-size: 2.4rem;
    margin-bottom: 4rem;
    text-align: center;
    font-weight: bold;
  }
`;

OurProducts.propTypes = propTypes;

export default OurProducts;
